import type { Permit, PermitFormKit } from "./permit";

export default {
  addAuthRequestFields,
  skinnyResponseAdapter,
  responseAdapter,
  getInitialData,
  toFormkit,
  fromFormkit,
};

function addAuthRequestFields(entity: Permit) {
  entity._authRequestFields = ["id", "statusMurn"] as (keyof Permit)[];
  return entity;
}

/** Be sure to await this when using it. Commonly used for lists and child lists */
async function skinnyResponseAdapter(response: { data: Permit }) {
  addAuthRequestFields(response.data);
  return response.data;
}

/** Be sure to await this when using it. */
async function responseAdapter(response: { data: Permit }) {
  await skinnyResponseAdapter(response);

  return response.data;
}

function getInitialData() {
  const result = {} as Permit;
  return addAuthRequestFields(result);
}

// Convert server data for use in the page's form (which may have groupings, etc different from the server data)
function toFormkit(data: Permit) {}

// Convert formkit data to prep it for sending to the server (which is probably flatter than the fk data)
function fromFormkit(data: PermitFormKit) {}
